export const ASM_DIALOGS_MAP = {
    ADD_NEW_USER: {
        id: 'add-new-user-dialog',
    },
    DELETE_USER: {
        id: 'delete-user-dialog',
    },
    MARK_ISSUES_RESOLVED: {
        id: 'mark-issue-resolved-dialog',
    },
    RESET_MFA: {
        id: 'reset-mfa-dialog',
    },
    ENFORCE_MFA: {
        id: 'enforce-mfa-dialog',
    },
    ENABLE_MFA: {
        id: 'enable-mfa-dialog',
    },
    DISABLE_MFA: {
        id: 'disable-mfa-dialog',
    },
    EDIT_USER: {
        id: 'edit-user-dialog',
    },
    WIZER_TRANSITION_SCREEN: {
        id: 'wizer-transition-screen-dialog',
    },
    EMPTY_DOMAINS: {
        id: 'empty-domains-dialog',
    },
    SCHEDULE_CALL: {
        id: 'schedule-call-dialog',
    },
    MDR_VIDEO: {
        id: 'mdr-video-dialog',
    },
    FRAUD_DEFENSE_VIDEO: {
        id: 'fraud-defense-dialog',
    },
    DELETE_INTEGRATION: {
        id: 'delete-integration-dialog',
    },
}
